import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, inject, PLATFORM_ID } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-roadmap',
  templateUrl: './roadmap.component.html',
  styleUrls: ['./roadmap.component.scss'],
  standalone: false
})
export class RoadmapComponent implements AfterViewInit {
  canRender: boolean = false;

  private readonly _platformId = inject(PLATFORM_ID);

  boxes = [
    {
      title: 'roadmap.box1_title',
      phase: 'roadmap.phase_1',
      icon: '/assets/images/webp/completed-tag.webp',
      features: ['roadmap.box1_li1', 'roadmap.box1_li2', 'roadmap.box1_li3', 'roadmap.box1_li4', 'roadmap.box1_li5', 'roadmap.box1_li6'],
      isCompleted: true,
    },
    {
      title: 'roadmap.box2_title',
      phase: 'roadmap.phase_2',
      icon: '/assets/images/webp/current-tag.webp',
      features: ['roadmap.box2_li1', 'roadmap.box2_li2', 'roadmap.box2_li3', 'roadmap.box2_li4', 'roadmap.box2_li5', 'roadmap.box2_li6', 'roadmap.box2_li7', 'roadmap.box2_li8'],
      isCompleted: true,
    },
    {
      title: 'roadmap.box3_title',
      phase: 'roadmap.phase_3',
      icon: '/assets/images/webp/next-tag.webp',
      features: ['roadmap.box3_li1', 'roadmap.box3_li2', 'roadmap.box3_li3', 'roadmap.box3_li4', 'roadmap.box3_li5', 'roadmap.box3_li6', 'roadmap.box3_li7', 'roadmap.box3_li8'],
      isCompleted: false,
    },
  ];

  slideOption: OwlOptions = {
    loop: false,
    autoplay: false,
    autoWidth: true,
    autoplayHoverPause: true,
    touchDrag: true,
    mouseDrag: true,
    dots: true,
    nav: false,
    center: true,
    startPosition: 0,
    margin: 20,
    responsive: {
      0: {
        items: 1.2,
        autoWidth: false,
        // loop:true
      },
      577: {
        items: 2,
      },
    },
  };

  getListItemIcon(boxIndex: number, listIndex: number, isCompleted: boolean): string {
    // For second box (index 1), only first 2 list items are completed
    if (boxIndex === 1) {
      return listIndex < 2 ? '/assets/images/svg-icons/active-phase.svg' : '/assets/images/svg-icons/none-active-phase.svg';
    }
    // For others, follow general completion status
    return isCompleted ? '/assets/images/svg-icons/active-phase.svg' : '/assets/images/svg-icons/none-active-phase.svg';
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this._platformId)) {
      this.canRender = true;
    }
  }
}
